<template>
  <div class="club-controller">
    <div class="community-card d-flex" style="width: 100%">
      <v-col cols="12" class="">
        <div class="text-center">
          <v-avatar :style="`border-color: #${getPrimaryColor()} !important;`"
            class="avatar-special mb-3" size="100">
            <v-img :src="clubAvatarSrc" contain></v-img>
          </v-avatar>
          <div class="flex-column">
            <h1>{{ this.$store.state.clubMember.club.name }}</h1>
            <p><b>{{ getRol() +
              " "
                }}</b> {{ $t('message_ClubController') }}</p>
            <div v-if="$store.state.clubMember.rol !== 'MEMBER'" class="d-flex justify-center">
              <v-btn v-if="false" @click="goToSettings" icon><v-icon x-small>fa-cog</v-icon></v-btn>
            </div>
          </div>
        </div>
      </v-col>
      <v-col v-if="false" style="position: absolute; right: 0; top: 200px;" cols="3">
        <events :events="events" :channel-name="capitalize(this.$store.state.currentClubChannel.name)"
          @event-click="goToEvents" />
      </v-col>
      <v-divider v-if="mainPartner"></v-divider>
      <div v-if="mainPartner" class="sponsored-by">
        <p>{{ $t('sponsoredBy') }}:</p>
        <img v-if="mainPartnerLogo" class="partner-image" :src="mainPartnerLogo" :alt="mainPartner.shortName">
      </div>      <p class="community-members"
        :style="`background-color: #${getPrimaryColor()}; color: ${getContrastTextColor} !important;`">
        {{ $t('table_ClubChannels.members') }}: <span class="members-count" :style="`color: ${getContrastTextColor} !important;`">{{ activeMembers }}</span>
      </p>
    </div>
    <div class="community-card d-flex mt-5" style="width: 100%">
      <events :events="events" :channel-name="capitalize(this.$store.state.currentClubChannel.name)"
        @event-click="goToEvents" />
    </div>
  </div>
</template>

<script>
import Repository from '../../../repositories/club';
import { mapMutations } from 'vuex';
import Events from '@/views/Events.vue'
import { getResponsiveLogo } from '@/utils/partnerLogos'

const DEFAULT_COMMUNITY_ICON_URL =
    'https://assets-db-bucket.s3.us-east-1.amazonaws.com/Community%20Icon.webp'

export default {
  name: "ClubController",
  components: {
    Events
  },
  data() {
    return {
      monthNames: [
        this.$t('months_ClubController.jan'),
        this.$t('months_ClubController.feb'),
        this.$t('months_ClubController.mar'),
        this.$t('months_ClubController.apr'),
        this.$t('months_ClubController.may'),
        this.$t('months_ClubController.jun'),
        this.$t('months_ClubController.jul'),
        this.$t('months_ClubController.aug'),
        this.$t('months_ClubController.sep'),
        this.$t('months_ClubController.oct'),
        this.$t('months_ClubController.nov'),
        this.$t('months_ClubController.dec')
      ],
      datePicker: null,
      events: [],
      pendingMembers: [],
      partnersData: null,
    };
  },
  computed: {
    activeMembers() {
      return this.$store.state.clubMembers.length - this.pendingMembers.length;
    },
    mainPartner() {
      if (!this.partnersData || !this.partnersData.partners) return null;
      return this.partnersData.partners.find(
        partner => partner.id === this.partnersData.mainPartnerId
      );
    },
    mainPartnerLogo() {
      return getResponsiveLogo(this.mainPartner);
    },
    getContrastTextColor() {
      // Check if clubMember and club exist and have primaryColor
      if (!this.$store.state.clubMember || 
          !this.$store.state.clubMember.club || 
          !this.$store.state.clubMember.club.primaryColor) {
        return '#FFFFFF'; // Default to white text
      }

      const hexColor = this.$store.state.clubMember.club.primaryColor;

      // Validate hex color format
      if (!hexColor || hexColor.length !== 6) {
        return '#FFFFFF'; // Default to white text for invalid hex
      }

      // Convert hex to RGB
      const r = parseInt(hexColor.substr(0, 2), 16);
      const g = parseInt(hexColor.substr(2, 2), 16);
      const b = parseInt(hexColor.substr(4, 2), 16);

      // Check for invalid RGB values
      if (isNaN(r) || isNaN(g) || isNaN(b)) {
        return '#FFFFFF'; // Default to white text for invalid RGB
      }

      // Calculate YIQ contrast ratio
      const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;

      // Return black for light backgrounds, white for dark backgrounds
      return yiq >= 128 ? '#000000' : '#FFFFFF';
    },
    clubAvatarSrc() {
      const club = this.$store.state.clubMember && this.$store.state.clubMember.club;
      const url = club && club.imageUrl;
      return url || DEFAULT_COMMUNITY_ICON_URL;
    }
  },
  watch: {
    '$store.state.clubEvents': function () {
      this.processEvents();
    },
    '$store.state.clubMembers': function () {
      this.seePendingRequests();
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getEvents();
      this.getClubChannelsContributedByMe();
      this.getClubPublicChannels();
      this.getPartners();
      //if(this.$store.state.clubMember.rol === 'FOUNDER' || this.$store.state.clubMember.rol === 'ADMIN')
      //  this.getClubChannels();
    },
    getRol() {
      return (this.$store.state.clubMember.rol === 'FOUNDER') ? this.$t('roles_ClubController.founder') :
        (this.$store.state.clubMember.rol === 'ADMIN') ? this.$t('roles_ClubController.admin') : this.$t('roles_ClubController.member');
    },
    ...mapMutations(['setClubEvents']),
    getEvents() {
      Repository.getAllClubEventsByChannel(this.$store.state.clubMember.club.id, this.$store.state.currentClubChannel.id).then((response) => {
        if (response.status < 400) {
          this.setClubEvents(response.data);
          this.processEvents();
        }
      });
    },
    ...mapMutations(['setClubMembers']),
    getMembers() {
      Repository.getAllClubMembers(this.$store.state.clubMember.club.id).then((response) => {
        if (response.status < 400) {
          this.setClubMembers(response.data);
          this.seePendingRequests();
        }
      });
    },
    ...mapMutations(['setClubChannels']),
    getClubChannels() {
      Repository.getAllClubChannels(this.$store.state.clubMember.club.id).then((response) => {
        if (response.status < 400)
          this.setClubChannels(response.data);
      });
    },
    ...mapMutations(['setClubChannelsContributedByMe']),
    getClubChannelsContributedByMe() {
      Repository.getAllClubChannelsByContributor(this.$store.state.clubMember.id).then((response) => {
        if (response.status < 400)
          this.setClubChannelsContributedByMe(response.data);
      });
    },
    ...mapMutations(['setClubPublicChannels']),
    getClubPublicChannels() {
      Repository.getAllPublicClubChannels(this.$store.state.clubMember.club.id).then((response) => {
        if (response.status < 400) {
          this.setClubPublicChannels(response.data);
          this.processEvents();
        }
      });
    },
    async getPartners() {
      try {
        const response = await Repository.getClubPartners(this.$store.state.clubMember.club.id);
        if (response.status < 400) {
          this.partnersData = response.data;
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching partners:', error);
      }
    },
    processEvents() {
      let now = new Date();
      this.events = [];
      this.$store.state.clubEvents.forEach((event) => {
        if (new Date(event.startDate) > now || new Date(event.endDate) > now)
          this.events.push(event);
      })
    },
    seePendingRequests() {
      this.pendingMembers = [];
      this.$store.state.clubMembers.forEach((member) => {
        if (member.rol === 'PENDING')
          this.pendingMembers.push(member);
      });
    },
    goToEvents() {
      this.$router.push('/club/events');
    },
    goToSettings() {
      this.$router.push('/club/settings');
    },
    capitalize(string) {
      return string[0] + string.slice(1).toLowerCase();
    },    getPrimaryColor() {
      // Return primary color if available, otherwise return default yellow color
      if (this.$store.state.clubMember && 
          this.$store.state.clubMember.club && 
          this.$store.state.clubMember.club.primaryColor) {
        return this.$store.state.clubMember.club.primaryColor;
      }
      return 'FFD700'; // Default yellow color
    },
  }
}
</script>



<style scoped lang="scss">
.community-card {
  border: 1px solid #9A9A9A;
  border-radius: 15px;
  background-color: var(--v-fullWhite-base);
  font-family: 'Avenir', sans-serif;
  width: 335px;
  padding: 20px 0;
  flex-direction: column;
  padding-bottom: 0;
}

.avatar-special {
  border: 2px solid !important;
  border-radius: 500px !important;
}

.community-members {
  padding: 10px;
  font-weight: bold;
  display: flex;
  border-bottom-left-radius: 14px;
  margin-top: 20px;
  border-bottom-right-radius: 14px;
  align-items: center;

  .members-count {
    display: flex;
    font-size: 24px !important;
    margin-left: auto;
  }
}

.sponsored-by {
  display: flex;
  padding: 20px;
  padding-bottom: 0;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex-direction: column;
  font-weight: bold;
}

.partner-image {
  max-height: 40px;
  max-width: 120px;
  object-fit: contain;
  margin-left: 10px;
}
</style>
